import React from 'react';
import { Link } from 'react-router-dom';
import {
  Button,
  Row,
  Col,
} from 'reactstrap';

import {
  Auth, Form, TextField, Intl,
} from 'components';
import { composeValidators, email, required } from 'config/InputErrors';

export default React.memo( ( { onSubmit } ) => (
  <Auth title="loginTitle">
    <Row className="justify-content-center">
      <Col lg="5" md="7">
        <Form
          onSubmit={onSubmit}
          showErrorsInHeader
        >
          <>
            <TextField
              field="username"
              validate={composeValidators( required, email )}
              label="email"
              formGroupClass="mt-3"
              labelClass="required"
            />
            <TextField
              field="password"
              type="password"
              validate={required}
              label="password"
              labelClass="required"
            />

            <Row>
              <Col className="mt-4 text-center">
                <Link
                  to="/auth/sign-up"
                  className="btn-link"
                >
                  <p className="m-0 lh-100 text-sm"><Intl id="registerQuestion" /></p>
                  <p className="m-0 lh-130 text-sm"><Intl id="registerHere" /></p>
                </Link>
              </Col>
            </Row>
            <Row>
              <Col className="text-center">
                <Link
                  to="/auth/forgot-password"
                  className="btn-link text-center text-sm text-black"
                >
                  <Intl id="forgotPasswordLink" />
                </Link>
              </Col>
            </Row>
          </>

          <div className="text-center mt-5">
            <Button color="app-default" size="app-sm" className="text-lg lh-130">
              <Intl id="login" />
            </Button>
          </div>
        </Form>
      </Col>
    </Row>
  </Auth>
) );
